import { models } from '@vote4dance/judging-sdk';
var RoundItemSdk = models.rounds.RoundItem;
export const RoundItem = RoundItemSdk;
export function groupItemsByRoundBeat(data) {
    const groupedRounds = [];
    data.forEach(round => {
        const lastGroup = groupedRounds[groupedRounds.length - 1];
        const lastRound = lastGroup && lastGroup[lastGroup.length - 1];
        let pushed = false;
        if (lastRound && lastRound.round_beat && lastRound.round_beat === round.round_beat && lastRound.class_id !== round.class_id) {
            groupedRounds.forEach(list => {
                let validScheduleId = list[0] && list[0].schedule_id;
                const groupClassIds = list.map(a => a.class_id);
                const groupBeats = list.map(a => a.round_beat);
                if ((validScheduleId ? validScheduleId === round.schedule_id : true) &&
                    !groupClassIds.includes(round.class_id) &&
                    groupBeats.includes(round.round_beat)) {
                    if (!pushed) {
                        list.push(round);
                        pushed = true;
                    }
                }
            });
        }
        if (!pushed) {
            groupedRounds.push([round]);
        }
    });
    return groupedRounds;
}
export const safeParseRoundSubmitValidation = (validation) => {
    if (!validation)
        return null;
    try {
        return JSON.parse(validation);
    }
    catch (e) {
        console.warn('Invalid round_submit_validation JSON', e);
        return null;
    }
};
export const buildRoundSubmitValidationFromThrough = (roundNumThrough, judgingSettings, currentValidation) => {
    if (roundNumThrough == null || Number.isNaN(roundNumThrough) || !judgingSettings) {
        return null;
    }
    if (judgingSettings.validation !== 'absolute' || !judgingSettings.template) {
        return null;
    }
    const groupOrder = [];
    const groupedEntries = {};
    (judgingSettings.entries || []).forEach((entry) => {
        var _a;
        const templateValue = (_a = judgingSettings.template) === null || _a === void 0 ? void 0 : _a[entry];
        if (templateValue === undefined)
            return;
        const groupKey = String(templateValue);
        if (!groupOrder.includes(groupKey)) {
            groupOrder.push(groupKey);
        }
        groupedEntries[groupKey] = groupedEntries[groupKey] || [];
        groupedEntries[groupKey].push(entry);
    });
    if (groupOrder.length === 0) {
        return null;
    }
    const parsedCurrentValidation = safeParseRoundSubmitValidation(currentValidation);
    const currentAbsolute = ((parsedCurrentValidation === null || parsedCurrentValidation === void 0 ? void 0 : parsedCurrentValidation.absolute) || {});
    const absolute = {};
    groupOrder.forEach((groupKey, index) => {
        groupedEntries[groupKey].forEach(entry => {
            if (index === 0) {
                absolute[entry] = roundNumThrough;
                return;
            }
            const existingValue = currentAbsolute[entry];
            absolute[entry] = existingValue != null ? existingValue : 1;
        });
    });
    return JSON.stringify({ absolute });
};
export const roundSubmitValidationPreview = (validation) => {
    const json = safeParseRoundSubmitValidation(validation);
    const values = (json && json.absolute) ? Object.values(json.absolute) : [];
    return values.join(', ');
};
